import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { ApiService } from 'app/main/shared/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class UserService implements Resolve<any> {



  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    if (state.url.includes('professor-category-list')) {
      try {
        let resolved: any = {};
        const res: any = await this.retrieveProfessorCategoryByFilterPaged('', 0, 10).catch((err) => {
          console.error(err);
          resolved = {
            list: [],
            count: 0
          };
        });
        if (res) {
          if (res.ok) {
            resolved = {
              list: res.payload,
              count: res.payload.length
            };
          }
        }
        return resolved;
      } catch (err) {
        this.router.navigateByUrl(``);
      }
    } else {
      try {
        const resolved: any = {};
        resolved.filterRole = route.queryParams.filterRole;
        return resolved;
      } catch (err) {
        console.log(err);
        this.router.navigateByUrl(``);
      }
    }
  }

  constructor(
    private api: ApiService,
    private router: Router
  ) {

  }

  getPatients() {
    return this.api.getRequest(`getPatientsList`);
  }

  getOperators() {
    return this.api.getRequest(`getOperatorsList`);
  }

  editPaziente(body: any) {
    return this.api.putRequest(`updateUserInfo`, body);
  }

  deletePaziente(userInfoId: any) {
    return this.api.deleteRequest(`users/${userInfoId}`);
  }

  deleteOperatore(userInfoId: any) {
    return this.api.deleteRequest(`users/${userInfoId}`);
  }

  async deleteUserPromise(userInfoId: any) {
    return this.api.deleteRequestPromise(`users/${userInfoId}`);
  }

  async canceUserDeletionPromise(userInfoId: any) {
    return this.api.putRequestPromise(`users/${userInfoId}/cancelDelete`, {});
  }

  editOperatore(body: any) {
    return this.api.putRequest(`updateUserInfo`, body);
  }

  async editUserPromise(body: any) {
    return this.api.putRequestPromise(`updateUserInfo`, body);
  }

  createOperator(body) {
    return this.api.postRequest(`updateUserInfo`, body);
  }

  async createUserPromise(body) {
    return this.api.postRequestPromise(`updateUserInfo`, body);
  }

  changeMyPassword(body: any) {
    return this.api.putRequest(`changePassword`, body);
  }

  changeUserPassword(id: any, body: any) {
    return this.api.putRequest(`users/${id}/changePassword`, body);
  }

  async changeUserPasswordPromise(id: any, body: any) {
    return this.api.putRequestPromise(`users/${id}/changePassword`, body);
  }

  changeUserUsername(id: any, body: any) {
    return this.api.putRequest(`users/${id}/changeUsername`, body);
  }

  async changeUserUsernamePromise(id: any, body: any) {
    return this.api.putRequestPromise(`users/${id}/changeUsername`, body);
  }
  async changeUserRolePromise(id: any, body: any) {
    return this.api.putRequestPromise(`users/${id}/changeRole`, body);
  }

  getUserInfoPromise() {
    return this.api.getRequest('getUserInfo').toPromise();
  }

  getUserInfo() {
    return this.api.getRequest('getUserInfo');
  }

  getUserInfoByUserId(userId) {
    return this.api.getRequest(`users/${userId}/getUserInfo`);
  }

  tokenRecognization(authtoken) {
    return this.api.getRequest(`/public/tokenRecognization?authtoken=${authtoken}`);
  }

  renderPatientProfileImage(userInfoId, profileImageId) {
    const noCache = new Date().getTime();
    const endpoint = `files/user/renderProfileImage?profileImageId=${profileImageId}&userInfoId=${userInfoId}&noCache=` + noCache;
    // const ret = this.sanitizer.bypassSecurityTrustResourceUrl(this.api
    //   .getBlobRequest(endpoint));
    // return ret;
    const ret = this.api
      .getBlobRequest(endpoint);
    return ret;
  }

  async retrieveUsersByFilterRolePaged(filterValue, fromValue, toValue, filterRole, pageIndex, pageSize) {
    return this.api.getRequestPromise(`users?filterRole=${filterRole}&filterString=${filterValue}&from=${fromValue}&to=${toValue}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
  }
  async getStudentsListFiltered(filterUsername) {
    return this.api.getRequestPromise(`getStudentsListFiltered?filterUsername=${filterUsername}`);
  }
  async getProfessorsListFiltered(filterUsername) {
    return this.api.getRequestPromise(`getProfessorsListFiltered?filterUsername=${filterUsername}`);
  }

  getRosCam(contactId) {
    return this.api.getRequest(`bo/getRosCam/${contactId}`);
  }

  // POST users/{userInfoId}/impersonification
  async impersonification(userInfoId) {
    return await this.api.postRequestPromise(
      `users/${userInfoId}/impersonification`,
      {}
    );
  }

  // Method to upload user photo
  async uploadMyPhoto(formData: FormData): Promise<any> {
    return this.api.postFileRequestPromise('users/myphoto/upload', formData);
  }

  async renderMyPhoto(): Promise<any> {
    return this.api.getBlobRequestPromise('users/myphoto/render?noCache=' + new Date().getTime());
  }

  async renderUserPhoto(userId, photoId): Promise<any> {
    return this.api.getBlobRequestPromise(`users/${userId}/files/${photoId}/render?noCache=` + new Date().getTime());
  }

  // Method to upload user curriculum
  async uploadMyCurriculum(formData: FormData): Promise<any> {
    return this.api.postFileRequestPromise('users/mycurriculum/upload', formData);
  }

  backofficeLogin(body) {
    return this.api.postRequestPromise('public/userLogin/backoffice', body);
  }

  async studentLogin(body) {
    return this.api.postRequestPromise(`public/userLogin/student`, body);
  }

  async professorLogin(body) {
    return this.api.postRequestPromise(`public/userLogin/professor`, body);
  }

  async studentRegistration(formData: FormData): Promise<any> {
    return this.api.postFileRequestPromise('public/userRegistration/student', formData);
  }

  async checkRegistrationCode(body) {
    return this.api.postRequestPromise(`public/userRegistration/checkCode`, body);
  }

  async professorRegistration(body) {
    return this.api.postRequestPromise(`public/userRegistration/professor`, body);
  }

  async resendRegistrationCode(body) {
    return this.api.postRequestPromise(`public/userRegistration/resendCode`, body);
  }

  async isAlreadyPresentUsername(body) {
    return this.api.postRequestPromise(`public/userRegistration/isAlreadyPresentUsername`, body);
  }

  async resetPassword(body) {
    return this.api.postRequestPromise(`public/resetPassword`, body);
  }

  async confirmResetPassword(body) {
    return this.api.postRequestPromise(`public/confirmResetPassword`, body);
  }

  deactivateZoom(id) {
    return this.api.putRequestPromise(`users/${id}/zoom/deactivate`, {});
  }

  activateZoom(id) {
    return this.api.putRequestPromise(`users/${id}/zoom/activate`, {});
  }

  deactivatePublicPage(id) {
    return this.api.putRequestPromise(`users/${id}/publicPage/deactivate`, {});
  }

  activatePublicPage(id) {
    return this.api.putRequestPromise(`users/${id}/publicPage/activate`, {});
  }

  updateZoom(id) {
    return this.api.putRequestPromise(`users/${id}/zoom/update`, {});
  }

  retrieveDashboardObj() {
    return this.api.getRequest('users/dashboardObj').toPromise();
  }

  async deleteMyAccountRequest() {
    return this.api.putRequestPromise(`users/deleteMyAccountRequest`, {});
  }

  retrieveProfessorCatories() {
    return this.api.getRequest('users/professorCategories').toPromise();
  }

  async retrieveProfessorCategoryByFilterPaged(filterValue, pageIndex, pageSize) {
    return await this.api.getRequestPromise(`users/professorCategory?filterString=${filterValue}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
  }

  async editProfessorCategory(professorCategory) {
    return await this.api.putRequestPromise(`users/professorCategory`, professorCategory);
  }

}
